// AnsichtsKnopf.tsx — Klickfläche, die auch im gesperrten Formular lebt.
//
// Die Akte sperrt ihre Maske mit `<fieldset disabled>`. Das schaltet jeden
// <button> darin tot — auch Knöpfe, die nichts ändern (Anrufen, Mail, Karte,
// Beziehung ansehen). Diese Knöpfe sind deshalb ein <span role="button"> mit
// Tastatur-Bedienung wie ein Knopf.

import * as React from "react";

/**
 * Liegt das Element in einem gesperrten Formular (`<fieldset disabled>`)?
 * Dann darf ein Popup nur zeigen, nicht ändern.
 */
export const imGesperrtenFormular = (el: Element | null | undefined): boolean =>
  !!el?.closest?.("fieldset[disabled]");

/**
 * Klickfläche, die ein gesperrtes Formular NICHT abschaltet (kein <button>),
 * mit Tastatur-Bedienung wie ein Knopf (Enter/Leertaste).
 *
 * `deaktiviert`: sichtbar, aber ohne Aktion (`aria-disabled`, nicht fokussierbar).
 */
export function AnsichtsKnopf({
  label,
  title,
  className,
  style,
  deaktiviert,
  onClick,
  children,
}: {
  label: string;
  /** Tooltip, falls abweichend vom `label`. */
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  deaktiviert?: boolean;
  onClick: (el: HTMLElement) => void;
  children: React.ReactNode;
}) {
  return (
    <span
      role="button"
      tabIndex={deaktiviert ? -1 : 0}
      title={title ?? label}
      aria-label={label}
      aria-disabled={deaktiviert || undefined}
      className={className}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        if (deaktiviert) return;
        onClick(e.currentTarget);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (deaktiviert) return;
          onClick(e.currentTarget);
        }
      }}
    >
      {children}
    </span>
  );
}
